// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M10 19l-7-7m0 0l7-7m-7 7h18\"/> </svg> ";
// Exports
module.exports = code;